import styled from "@emotion/styled";
import { useEffect } from "react";
import CONFIG from "../config";
import { avatarColors } from "../utils/AvatarColors";

const AvatarImage = styled.img<{ size: number }>`
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  border-radius: 50%;
  cursor: pointer;
`;

const SvgContainer = styled.div<{ size: number; onClick: any }>`
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  cursor: ${({ onClick }) => onClick && "pointer"};
`;

interface UserSvgProps {
  userName: string;
  mode?: "CIRCLE" | "SQUARE";
}

export const DefaultUserSvg = ({ userName, mode = "CIRCLE" }: UserSvgProps) => {
  function getColor(name: string) {
    const color = avatarColors(name?.[0] || "");
    return color;
  }

  function getFirstLetter(name: string) {
    return name?.[0] || "";
  }

  return (
    <svg
      version="1.1"
      baseProfile="full"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0, 0, 100, 100"
    >
      {mode === "CIRCLE" ? (
        <circle
          cx="50"
          cy="50"
          r="49"
          fill={getColor(userName) || "#EEEEEE"}
          stroke="#DDDDDD"
          stroke-width="1"
        />
      ) : (
        <rect width="100" height="100" fill={getColor(userName) || "#EEEEEE"} />
      )}
      <text
        x="50"
        y="71.5"
        font-family="Arial"
        font-size="60"
        font-weight="700"
        textAnchor="middle"
        fill="#ffffff"
      >
        {getFirstLetter(userName)}
      </text>
    </svg>
  );
};

interface Props {
  email?: string;
  image?: string | undefined | null;
  size: number;
  userName?: string;
  absoluteURL?: string;
  onAvatarClick?: () => void;
}

const AvatarIcon = (props: Props): JSX.Element => {
  const { image, absoluteURL, userName, size, onAvatarClick, email } = props;

  useEffect(() => {
    // se for um usuário
    if (!userName) {
      console.warn("Every non lair avatar must have an userName");
    }
  }, []);

  if (absoluteURL) {
    return (
      <AvatarImage
        onClick={onAvatarClick}
        style={{ cursor: onAvatarClick ? "pointer" : "default" }}
        src={`${absoluteURL}`}
        size={size}
      />
    );
  } else if (image) {
    return (
      <AvatarImage
        onClick={onAvatarClick}
        style={{ cursor: onAvatarClick ? "pointer" : "default" }}
        src={`${CONFIG.BUCKET_URL}/file/local/${image}`}
        size={size}
      />
    );
  } else {
    return (
      <SvgContainer size={size} onClick={onAvatarClick}>
        <DefaultUserSvg userName={userName || email?.toUpperCase()} />
      </SvgContainer>
    );
  }
};

export default AvatarIcon;
